import { render } from "./AdminContentEditor.vue?vue&type=template&id=13f57b5d&scoped=true"
import script from "./AdminContentEditor.vue?vue&type=script&lang=js"
export * from "./AdminContentEditor.vue?vue&type=script&lang=js"

import "./AdminContentEditor.vue?vue&type=style&index=0&id=13f57b5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f57b5d"]])

export default __exports__